"use strict";
exports.__esModule = true;
var ramda_1 = require("ramda");
var utils_1 = require("../utils");
var generateAppConfig = function (user) {
    var config = {};
    var scopes = user.scopes, gates = user.gates, roles = user.roles;
    var isReportingUser = utils_1.getIsReportingUser(roles);
    var isPlaybooksUser = utils_1.getIsPlaybooksUser(roles);
    var isVideoUserOnly = utils_1.getIsVideoUserOnly(scopes);
    var isCalendarUser = utils_1.getIsCalendarUser(scopes, gates);
    var isBotsV2User = utils_1.getIsBotsV2User(gates);
    var isOrgAdmin = utils_1.getIsOrgAdmin(scopes);
    var hasShipyard = ramda_1.pathOr(false, ['has_public_shipyard'], gates);
    var hasConversationFreeOrg = utils_1.getConversationFreeOrg(gates);
    /*** Main Nav ***/
    if (isVideoUserOnly || isBotsV2User) {
        config = ramda_1.set(ramda_1.lensProp('hasShipyard'), false, config);
        config = ramda_1.set(ramda_1.lensProp('hasProfile'), false, config);
    }
    else { // else member, admin, calendar-only, reporting, playbooks
        config = ramda_1.set(ramda_1.lensProp('hasShipyard'), hasShipyard, config);
    }
    /*** Popover ***/
    if (isVideoUserOnly || isBotsV2User || hasConversationFreeOrg || isCalendarUser || isPlaybooksUser || isReportingUser) {
        config = ramda_1.set(ramda_1.lensProp('hasNotifications'), false, config);
    }
    else { // else member, admin, calendar-only
        config = ramda_1.set(ramda_1.lensProp('hasNotifications'), true, config);
    }
    if (isVideoUserOnly || isCalendarUser || isBotsV2User || isReportingUser || isPlaybooksUser) {
        config = ramda_1.set(ramda_1.lensProp('hasAgentStatus'), false, config);
    }
    else { // else member or admin
        config = ramda_1.set(ramda_1.lensProp('hasAgentStatus'), true, config);
    }
    if (isBotsV2User) {
        config = ramda_1.set(ramda_1.lensProp('hasDriftStatus'), false, config);
    }
    else {
        config = ramda_1.set(ramda_1.lensProp('hasDriftStatus'), isOrgAdmin, config);
    }
    /*** Account Switcher ***/
    config = ramda_1.set(ramda_1.lensProp('hasDevPlatformSwitch'), !isBotsV2User, config);
    config = ramda_1.set(ramda_1.lensProp('hasInsiderSwitch'), !isBotsV2User, config);
    config = ramda_1.set(ramda_1.lensProp('hasVideoSwitch'), !isBotsV2User, config);
    return config;
};
exports["default"] = generateAppConfig;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@driftt/app-config/dist/appConfigs/trafficControl/index.js
// module id = th81
// module chunks = 88